import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import {
    IExtendVideoGeneration,
    IGenerateVideoFromAsset,
    IGenerateVideoFromSimpleText,
} from '../../../services/http-models/asset/asset-http-request-model';
import { IGeneratedVideoSocketData } from '../../../models/socket-events/workspace/asset/workspace-asset-event';
import { ConfigurationService } from '../../../services/configuration.service';
import {
    AssetsMainManagerService,
    IAssetMainService,
    IGeneratedAssetResponse,
} from '../../../pages/private/dashboard/assets/assets-main/assets-main-manager.service';
import { GenerateNewAssetFunctionalService } from './generate-new-asset-functional.service';
import { Subject, takeUntil } from 'rxjs';
import { fadeInOnEnterAnimation, fadeOutOnLeaveAnimation } from 'angular-animations';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationModalComponent } from '../../dialogs/confirmation-modal/confirmation-modal.component';
import { IAssetData } from '../../../pages/private/dashboard/assets/assets.component';
import { GenerateAssetTypeManagerService } from './generate-asset-type-managment.service';
import {
    ASPECT_RATIO_ENUM,
    AssetType,
    IGenerateAssetFromReference,
    IGenerateAssetFromText,
    IGenerateImageSettingsChange,
    IGenerateVideoSettingsChange,
    IImageGenerateModel,
    IMAGE_MODELS_BY_PRESET,
    ImageModelPreset,
    IVideoGenerateModel,
    VIDEO_GENERATION_MODELS_ENUM,
    ViewMode,
} from '../../../models/assets-model';
import { SnackbarActionEnum, SnackBarService } from '../../../services/utils/snack-bar.service';
import { ILocalAsset } from '../../../models/assets/assets.model';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';

@Component({
    selector: 'app-generate-asset-section',
    templateUrl: './generate-asset-section.component.html',
    styleUrl: './generate-asset-section.component.scss',
    animations: [
        fadeInOnEnterAnimation({ duration: 250, delay: 0 }),
        fadeOutOnLeaveAnimation({ duration: 250, delay: 0 }),
    ],
})
export class GenerateAssetSectionComponent implements OnInit, OnDestroy {
    enableEditImage: boolean;
    @Input({ alias: 'enableEditImage' })
    set setToEnableEditImage(isEnableEditImage: boolean) {
        this.enableEditImage = isEnableEditImage;
        this.initEditImageButtonByCurrentState();
    }
    @Input({ alias: 'enableImageToVideo' }) enableImageToVideo = false;
    /** User prompt text */
    prompt: string;
    isPromptValid: boolean = false;

    onEditImage: boolean = false;
    /** CDN base URL for constructing image/video URLs */
    baseCdnUrl: string;

    /** Reference to asset manager APIs */
    assetMainService: IAssetMainService;

    /** ID of the reference asset being used as input */
    referenceAssetId: string;

    isExtendingVideo: boolean = false;

    /** Whether we are generating an image or video */
    assetType: AssetType = 'image';
    isImageAssetType = true;
    /** Generated asset result (image or video) */
    // generatedAssetUrl: string;
    generatedImageUrl: string;
    generatedVideoUrl: string;

    toDisplayEditImageButton: boolean = false;
    toDisplayToIncludeLogo: boolean = false;
    toDisplayExtendVideo: boolean = false;
    generatedAsset: ILocalAsset;
    /** Emits video generation request */
    @Output('generateVideo') generateVideo = new EventEmitter<{
        startFromAsset: IGenerateVideoFromAsset;
        startFromSimpleText: IGenerateVideoFromSimpleText;
        extendVideo: IExtendVideoGeneration;
    }>();
    /** Emits image generation request */
    @Output('generateImage') generateImage = new EventEmitter<{
        startFromAsset: IGenerateAssetFromReference | null;
        startFromSimpleText: IGenerateAssetFromText | null;
    }>();
    /** Emits when user chooses to edit an image */
    @Output('editImage') editImage = new EventEmitter<{ assetId: string }>();
    /** Emits when user decides to use the generated asset */
    @Output('useGeneratedAsset') useGeneratedAsset = new EventEmitter<{ asset: ILocalAsset }>();
    @Output('resetAssetData') resetAssetData = new EventEmitter<void>();
    @Input({ alias: 'showUseButton', required: false })
    showUseButton: boolean = false;
    /** UI state */
    currentViewMode: ViewMode = 'input';
    toDisplayAssetsLibrary: boolean = false;
    showAdvancedOptions = false;
    isAbleToSeePreviewScreen: boolean = false;
    isGeneratingProcessGoingOn = false;
    /** Right panel: settings panel expanded or not */
    isSettingsOpen = false;
    /** Currently selected asset */
    currentAsset: ILocalAsset;
    /** Destroy stream for unsubscribing */
    onDestroy$ = new Subject<boolean>();
    imageModels: IImageGenerateModel[];
    videoModels: IVideoGenerateModel[];
    selectedImageModel: IImageGenerateModel;
    previousImageModel: IImageGenerateModel;
    selectedVideoModel: IVideoGenerateModel;
    // Aspect ratios
    aspectRatios: ASPECT_RATIO_ENUM[];
    selectedAspectRatio: ASPECT_RATIO_ENUM;
    isAspectRatioChosenByUser: boolean = false;
    currentImageAspectRation: ASPECT_RATIO_ENUM;
    @Output() selectedUrl = new EventEmitter<IAssetData>();
    promptLabel: string;
    headerText: string;
    lottiePath: string;
    buttonText: string;
    promptCreateText: string;
    promptUseImageText: string;
    includeLogo = false;
    constructor(
        private configurationService: ConfigurationService,
        private assetsMainConfigs: AssetsMainManagerService,
        private generateAssetFuncService: GenerateNewAssetFunctionalService,
        public dialog: MatDialog,
        private generateAssetTypeManagement: GenerateAssetTypeManagerService,
        private snackBarService: SnackBarService
    ) {
        // Load CDN base URL from configuration
        this.baseCdnUrl = this.configurationService.baseCdnUrl;
        this.generateAssetTypeManagement.setIsInGenerateComponent(true);
        this.setExpendVideoAsync();
    }
    private async setExpendVideoAsync() {
        await this.generateAssetFuncService.setFeatureAccessForGenerateAsync();
        this.toDisplayExtendVideo = this.generateAssetFuncService.toDisplayExtendVideoOption;
        this.toDisplayToIncludeLogo = this.generateAssetFuncService.toDisplayIncludeLogoOption;
    }
    @Input({ alias: 'assetType', required: false })
    set setCurrentAssetTypeFromInput(assetType: AssetType) {
        this.setCurrentAssetType(assetType);
    }

    /** When generating starts from outside, switch to preview mode */
    @Input({ alias: 'isGenerating', required: false })
    set setIsGenerating(isGenerating: boolean) {
        if (isGenerating) {
            this.isGeneratingProcessGoingOn = true;
            this.setCanSeePreview(true);
        }
    }

    /** Called when backend returns an image URL */
    @Input({ alias: 'generatedImageUrl', required: false })
    set setGeneratedImageUrl(assetData: IGeneratedAssetResponse | null) {
        if (!assetData) return;

        // Ensure URL is absolute
        const isAbsolute = assetData.uploadPath.startsWith('http://') || assetData.uploadPath.startsWith('https://');
        this.setGenerateImageUrl(isAbsolute ? assetData.uploadPath : this.baseCdnUrl + assetData.uploadPath, false);
        this.referenceAssetId = assetData.assetId;
        this.generatedAsset = assetData.asset;
        if (this.isGeneratingProcessGoingOn) {
            this.isGeneratingProcessGoingOn = false;
            this.snackBarService.openMessage('Image saved at assets library', SnackbarActionEnum.AWESOME, 4000);
        }
    }

    /** Called when socket returns final asset data */
    @Input({ alias: 'generatedAssetData', required: false })
    set setGeneratedAssetData(generatedAssetData: IGeneratedVideoSocketData) {
        if (generatedAssetData) {
            this.generateAssetFuncService.setGeneratedAssetId(generatedAssetData.assetId);
        }
    }

    ngOnInit() {
        this.initImageModels();
        this.initVideoModels();
        this.generateAssetTypeManagement.currentAssetContext$.pipe(takeUntil(this.onDestroy$)).subscribe((data) => {
            if (!data) {
                return;
            }
            this.assetType = data.assetType;
            this.initAspectRatios();
            this.isImageAssetType = data.assetType === 'image';
            this.initEditImageButtonByCurrentState();

            this.updateUI();
        });
        this.generateAssetTypeManagement.setCurrentAssetType(this.assetType);
        // Subscribe to asset manager service instance
        this.assetsMainConfigs.assetMainConfigs$.pipe(takeUntil(this.onDestroy$)).subscribe((data) => {
            this.assetMainService = data;
        });

        // Subscribe to changes in selected asset ID
        this.generateAssetFuncService.currentAssetId$.pipe(takeUntil(this.onDestroy$)).subscribe((assetId) => {
            if (assetId) {
                this.referenceAssetId = assetId;
                this.setDisplayAssetLibrary(false);
            }
        });

        // Subscribe to full asset model (if selected)
        this.generateAssetFuncService.currentAsset$.pipe(takeUntil(this.onDestroy$)).subscribe((asset) => {
            if (!asset) return;
            this.currentAsset = asset;
        });

        // Subscribe to reference image URL
        this.generateAssetFuncService.currentImageAssetUrl$.pipe(takeUntil(this.onDestroy$)).subscribe((imageUrl) => {
            if (!this.generatedImageUrl) {
                this.trySetImageFromAssetUrl(imageUrl);
            }
        });

        // Final generated asset
        this.generateAssetFuncService.generatedAssetUrl$.pipe(takeUntil(this.onDestroy$)).subscribe((url) => {
            if (!url) {
                return;
            }
            this.trySetImageFromAssetUrl(url);
        });

        // Subscribe to final generated asset (full model)
        this.generateAssetFuncService.generatedAsset$.pipe(takeUntil(this.onDestroy$)).subscribe((asset) => {
            if (!asset && !this.isGeneratingProcessGoingOn) return;

            const isVideo = this.isVideoFile(asset.uploadPath);
            if (!isVideo) {
                return;
            }
            this.snackBarService.openMessage('Video saved at assets library', SnackbarActionEnum.AWESOME, 4000);
            this.generatedAsset = asset;
            this.referenceAssetId = asset._id;
            this.isGeneratingProcessGoingOn = false;
            this.generatedVideoUrl = this.baseCdnUrl + asset.uploadPath;
            this.setCanSeePreview(true);
        });
    }
    /** Called when user clicks "Generate" */
    onGenerate() {
        if (!this.isPromptValid) {
            this.snackBarService.openMessage(`Prompt is not valid`, SnackbarActionEnum.Close, 5000);
            return;
        }
        if (this.isImageAssetType) {
            // IMAGE GENERATION
            this.setGenerateImageUrl(null, false);

            this.generateImage.emit({
                startFromAsset: this.onEditImage
                    ? {
                          assetId: this.referenceAssetId,
                          enrichWithText: this.prompt,
                          model: this.selectedImageModel.value,
                          aspectRatio: this.selectedAspectRatio,
                          toUseLogo: this.includeLogo,
                      }
                    : null,
                startFromSimpleText: this.onEditImage
                    ? null
                    : {
                          text: this.prompt,
                          model: this.selectedImageModel.value,
                          aspectRatio: this.selectedAspectRatio,
                          toUseLogo: this.includeLogo,
                      },
            });

            return;
        }
        // VIDEO GENERATION
        this.handleVideoGeneration();
    }
    handleVideoGeneration() {
        if (!this.currentImageAspectRation || this.selectedAspectRatio === this.currentImageAspectRation) {
            this.startGeneratingVideo();
            return;
        }

        const dialogRef = this.dialog.open(ConfirmationModalComponent, {
            width: '550px',
            data: {
                title: {
                    htmlContent: 'Mismatch with aspect ratios, adjust the aspect ratios?',
                    align: 'center',
                    css: { color: '', style: {} },
                },
                body: [],
                buttons: [
                    {
                        text: 'Cancel',
                        css: { color: 'default', style: {} },
                        callback: () => dialogRef.close(),
                    },
                    {
                        text: 'Confirm',
                        css: { color: 'primary', style: {} },
                        callback: () => {
                            this.startGeneratingVideo();
                        },
                    },
                ],
            },
        });
    }

    startGeneratingVideo() {
        this.generatedAsset = null;
        const hasReferenceAsset = !!this.referenceAssetId;

        this.generatedVideoUrl = '';
        this.isGeneratingProcessGoingOn = true;
        this.generateVideo.emit({
            startFromAsset:
                hasReferenceAsset && !this.isExtendingVideo
                    ? {
                          assetId: this.referenceAssetId,
                          enrichImageWithText: this.prompt,
                          model: this.selectedVideoModel.value,
                          needToChangeAspectRatio: this.currentImageAspectRation
                              ? this.currentImageAspectRation !== this.selectedAspectRatio
                              : false,
                          aspectRatio: this.selectedAspectRatio,
                      }
                    : null,
            extendVideo:
                hasReferenceAsset && this.isExtendingVideo
                    ? {
                          assetId: this.referenceAssetId,
                          enrichVideoWithText: this.prompt,
                      }
                    : null,
            startFromSimpleText: hasReferenceAsset
                ? null
                : { text: this.prompt, model: this.selectedVideoModel.value, aspectRatio: this.selectedAspectRatio },
        });
    }
    /** Handle drag & drop file upload */
    async handleFileDropAsync(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();

        const files = event.dataTransfer?.files;
        if (!files || files.length === 0) {
            return;
        }

        const formData = new FormData();
        for (let i = 0; i < files.length; i++) {
            formData.append('files[]', files[i]);
        }

        const { data, error } = await this.assetMainService.uploadImageFromGenerateImage(formData);
    }

    onDragOver(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
        const label = event.currentTarget as HTMLElement;
        label.classList.add('dragover');
    }

    onDragLeave(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
        const label = event.currentTarget as HTMLElement;
        label.classList.remove('dragover');
    }

    /** Handle regular file input upload */
    async onFileSelectAsync(event: Event) {
        const input = event.target as HTMLInputElement;
        if (!input.files || input.files.length === 0) return;

        const formData = new FormData();
        for (let i = 0; i < input.files.length; i++) {
            formData.append('files[]', input.files[i]);
        }

        const { data, error } = await this.assetMainService.uploadImageFromGenerateImage(formData);

        if (error || !data) {
            console.error(`An error occurred when uploading file`);
            return;
        }
        // Select first uploaded asset as reference
        const response = data?.data ?? data;
        const uploaded = response?.uploaded;
        const asset = uploaded[0];
        const assetId = asset._id.toString();
        this.generateAssetFuncService.setCurrentAsset(assetId);
        this.setGenerateImageUrl(this.baseCdnUrl + asset.uploadPath, false);
    }

    /** Toggle advanced options panel */
    toggleAdvancedOptions() {
        this.showAdvancedOptions = !this.showAdvancedOptions;
    }

    /** When user clicks a suggested prompt */
    onPromptSelect(selectedText: string) {
        this.prompt = selectedText;
    }

    /** Settings (model, aspect ratio) changed */
    onImageSettingsChange(change: IGenerateImageSettingsChange) {
        this.setCurrentImageMode(change.model);
        this.onAspectRationSettingsChange(change.aspectRatio, true);
    }
    /** Settings (model, aspect ratio) changed */
    onVideoSettingsChange(change: IGenerateVideoSettingsChange) {
        this.selectedVideoModel = change.model;
        this.onAspectRationSettingsChange(change.aspectRatio, true);
    }
    onAspectRationSettingsChange(aspectRatio: ASPECT_RATIO_ENUM, didUserSwapped: boolean = false) {
        this.isAspectRatioChosenByUser = didUserSwapped;
        this.selectedAspectRatio = aspectRatio;
    }

    /** Remove currently selected reference asset */
    removeReferenceImage() {
        this.generateAssetFuncService.setCurrentAsset(null);
    }

    /** Switch between input and preview screens */
    setCurrentViewMode(mode: ViewMode) {
        this.currentViewMode = mode;
        this.initEditImageButtonByCurrentState();
        if (mode === 'input') {
            this.isExtendingVideo = false;
        }
    }

    /** User decides to use generated asset */
    onUseGeneratedAsset() {
        this.useGeneratedAsset.emit({ asset: this.generatedAsset });
    }
    /** Show/hide asset library panel */
    setDisplayAssetLibrary(toDisplay: boolean) {
        this.toDisplayAssetsLibrary = toDisplay;
    }

    /** Enable/disable ability to see preview screen */
    setCanSeePreview(canSeePreview: boolean) {
        this.isAbleToSeePreviewScreen = canSeePreview;
        this.setCurrentViewMode(canSeePreview ? 'preview' : 'input');
    }
    onImageModelChange(model: IImageGenerateModel) {
        this.onImageSettingsChange({ model: model, aspectRatio: this.selectedAspectRatio });
    }
    onVideoModelChange(model: IVideoGenerateModel) {
        this.selectedVideoModel = model;
        this.onVideoSettingsChange({ model: model, aspectRatio: this.selectedAspectRatio });
    }
    onAspectRatioChange(aspectRatio: ASPECT_RATIO_ENUM) {
        this.isAspectRatioChosenByUser = true;
        this.onAspectRationSettingsChange(aspectRatio, true);
    }
    generateVideoFromImage() {
        this.setCurrentAssetType('video');
        this.prompt = '';
        this.setOnEditImage(false);
        this.setCanSeePreview(false);
    }
    initImageModels() {
        this.setImageModelPreset('all');
    }
    initVideoModels() {
        this.videoModels = [
            { name: 'Veo 3', value: VIDEO_GENERATION_MODELS_ENUM.VIDEO_VEO3 },
            // { name: 'Sora 2', value: VIDEO_GENERATION_MODELS_ENUM.VIDEO_SORA2 },
        ];
        this.selectedVideoModel = this.videoModels[0];
    }
    initAspectRatios() {
        if (!this.isImageAssetType && this.aspectRatios?.length === 2) {
            return;
        }
        if (this.isImageAssetType) {
            this.aspectRatios = [
                ASPECT_RATIO_ENUM._16_9,
                ASPECT_RATIO_ENUM._9_16,
                ASPECT_RATIO_ENUM._1_1,
                ASPECT_RATIO_ENUM._4_3,
                ASPECT_RATIO_ENUM._3_4,
            ];
        } else {
            this.aspectRatios = [ASPECT_RATIO_ENUM._16_9, ASPECT_RATIO_ENUM._9_16];
        }
        this.onAspectRationSettingsChange(this.aspectRatios[0]);
    }
    startNewChat() {
        this.generatedAsset = null;
        this.generatedVideoUrl = null;
        this.prompt = '';
        this.referenceAssetId = null;
        // this.generateAssetFuncService.setCurrentImageUrl(null);
        this.generateAssetFuncService.setGenerateAssetObject(null);
        this.generateAssetFuncService.setGeneratedAssetId(null);

        this.setGenerateImageUrl(null, true);
        this.setOnEditImage(false);
        this.initImageModels();
        this.initVideoModels();
        this.setCanSeePreview(false);
    }
    regenerateVideo() {
        this.setCanSeePreview(false);
    }
    startEditImage(toResetPrompt: boolean) {
        this.setCurrentAssetType('image');
        this.setOnEditImage(true);
        if (this.imageModels.length > 1) {
            this.setImageModelPreset('logo-only');
        }
        if (toResetPrompt) {
            this.prompt = '';
        }
        this.setCanSeePreview(false);
    }

    onImageLoad(event: Event) {
        const currentAspectRatio = this.selectedAspectRatio;
        if (currentAspectRatio && this.aspectRatios.includes(currentAspectRatio) && this.isAspectRatioChosenByUser) {
            return;
        }
        const img = event.target as HTMLImageElement;
        const width = img.naturalWidth;
        const height = img.naturalHeight;

        const aspect = width / height;
        this.currentImageAspectRation = this.findClosestRatio(aspect);
        this.onAspectRationSettingsChange(this.currentImageAspectRation);
    }

    setOnEditImage(onEditImage: boolean) {
        this.onEditImage = onEditImage;
        this.initEditImageButtonByCurrentState();
        this.updateUI();
    }

    setGenerateImageUrl(url: string, toResetPrompt: boolean) {
        this.generatedImageUrl = url;
        this.initEditImageButtonByCurrentState();
        if (this.isImageAssetType && url) {
            this.startEditImage(toResetPrompt);
        }
        this.updateUI();
    }

    onPromptSubmit(event: KeyboardEvent) {
        event.preventDefault();
        if (!this.prompt) return;
        this.onGenerate();
    }

    private findClosestRatio(aspect: number): ASPECT_RATIO_ENUM | null {
        let closest: ASPECT_RATIO_ENUM | null = null;
        let smallestDiff = Infinity;

        for (const ratio of this.aspectRatios) {
            const numeric = this.parseRatio(ratio);
            const diff = Math.abs(numeric - aspect);

            if (diff < smallestDiff) {
                smallestDiff = diff;
                closest = ratio;
            }
        }

        return closest;
    }

    private setCurrentAssetType(assetType: AssetType) {
        this.generateAssetTypeManagement.setCurrentAssetType(assetType);
    }

    private updateUI() {
        // Prompt label
        if (this.onEditImage) {
            this.promptLabel = 'Describe how to edit this image...';
        } else {
            this.promptLabel = this.isImageAssetType
                ? 'Describe your image in detail...'
                : 'Describe your video in detail...';
        }

        // Header text
        if (this.isImageAssetType) {
            this.headerText = this.onEditImage ? 'Edit Image' : 'Generate Image';
        } else {
            this.headerText = 'Generate Video';
        }

        // Lottie path
        this.lottiePath = this.isImageAssetType
            ? 'assets/animations/generate-image-icon.json'
            : 'assets/animations/video-player.json';

        // Button text
        if (this.onEditImage) {
            this.buttonText = 'Edit';
        } else if (!this.isImageAssetType) {
            this.buttonText = 'Generate';
        } else {
            this.buttonText = this.generatedImageUrl ? 'Regenerate' : 'Generate';
        }

        this.promptCreateText = `Enter your text prompt to create a ${!this.isImageAssetType ? 'video' : 'image'}.`;

        this.promptUseImageText = !this.isImageAssetType ? 'a starting frame' : 'a reference or starting point';
    }

    private parseRatio(ratio: ASPECT_RATIO_ENUM): number {
        const [w, h] = ratio.split(':').map(Number);
        return w / h;
    }

    onIncludeLogoChange(event: MatSlideToggleChange) {
        this.setImageModelPreset(event.checked || this.onEditImage ? 'logo-only' : 'all');
    }

    ngOnDestroy() {
        // Cleanup subscriptions
        this.onDestroy$.next(true);
        this.onDestroy$.complete();
        this.resetAssetData.emit();
        this.generateAssetFuncService.setCurrentImageUrl(null);
        this.generateAssetFuncService.setGenerateAssetObject(null);
        this.generateAssetFuncService.setGeneratedAssetId(null);
        this.setCanSeePreview(false);
        this.generateAssetTypeManagement.setIsInGenerateComponent(false);
    }
    private trySetImageFromAssetUrl(url: string | null | undefined): void {
        if (!url) {
            return;
        }

        if (this.isVideoFile(url)) {
            return;
        }

        this.setGenerateImageUrl(url, false);
    }
    private isVideoFile(url: string) {
        if (!url) return false;

        const videoExtensions = ['mp4', 'webm', 'mov', 'avi', 'mkv', 'flv', 'wmv', 'm4v', '3gp'];

        const cleanUrl = url.split('?')[0];
        const extension = cleanUrl.split('.').pop()?.toLowerCase();

        return !!extension && videoExtensions.includes(extension);
    }

    setCurrentImageMode(model: IImageGenerateModel) {
        this.previousImageModel = this.selectedImageModel;
        this.selectedImageModel = model;
    }

    private setImageModelPreset(preset: ImageModelPreset) {
        const nextModels = IMAGE_MODELS_BY_PRESET[preset];
        this.imageModels = nextModels;

        let nextModelToSet: IImageGenerateModel;
        if (preset === 'all') {
            nextModelToSet = nextModels[0];
        }
        if (!nextModelToSet) {
            const current = this.previousImageModel;

            nextModelToSet = current ? nextModels.find((m) => m.value === current.value) : null;
        }

        this.setCurrentImageMode(nextModelToSet ?? nextModels[0]);
    }
    onPromptInput(event: Event) {
        const value = (event.target as HTMLInputElement).value;

        this.isPromptValid = this.validatePrompt(value);
    }
    private validatePrompt(value: string): boolean {
        if (!value) {
            return false;
        }

        const normalized = value.trim();

        // at least one real word (unicode-safe)
        return /\p{L}{2,}/u.test(normalized);
    }

    private initEditImageButtonByCurrentState() {
        if (
            ((!this.isImageAssetType && this.currentViewMode === 'input') || this.isImageAssetType) &&
            this.generatedImageUrl &&
            this.enableEditImage &&
            !this.onEditImage
        ) {
            this.toDisplayEditImageButton = true;
            return;
        }
        this.toDisplayEditImageButton = false;
    }
}
